import { render, staticRenderFns } from "./material-statistics.vue?vue&type=template&id=235eeea7&scoped=true"
import script from "./material-statistics.vue?vue&type=script&lang=js"
export * from "./material-statistics.vue?vue&type=script&lang=js"
import style0 from "./material-statistics.vue?vue&type=style&index=0&id=235eeea7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235eeea7",
  null
  
)

export default component.exports